<template>
  <a
    :href="`https://twitter.com/intent/tweet?url=${fullUrl}&hashtags=continent`"
    data-size="large"
    target="_blank"
    class="no-underline"
    >
    <span class="icon icon-twitter"></span>
  </a>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  computed: {
    fullUrl () {
      return window.location.origin + this.$route.fullPath
    }
  }
}
</script>
